import React, { memo } from "react";

const Song = memo(() => {
	return <div>Song</div>;
});

export default Song;
